module.exports = __webpack_public_path__ + "img/ed596d1.png";